import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import RouteIcon from "@mui/icons-material/Route";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import StarIcon from "@mui/icons-material/Star";
import NotificationsIcon from "@mui/icons-material/Notifications";

export const vayuSidebarItems = [
  {
    key: "dashboard",
    name: "Dashboard",
    path: "/dashboard",
    icon: DashboardIcon,
    activeIcon: DashboardIcon,
  },
  {
    key: "bookings",
    name: "Bookings",
    path: "/bookings",
    icon: BookOnlineIcon,
    activeIcon: BookOnlineIcon,
  },
  {
    key: "captains",
    name: "Captains",
    path: "/captains",
    icon: PersonIcon,
    activeIcon: PersonIcon,
  },
  // {
  //   key: "routes",
  //   name: "Routes",
  //   path: "/routes",
  //   icon: RouteIcon,
  //   activeIcon: RouteIcon,
  // },
  {
    key: "schools",
    name: "Schools",
    path: "/schools",
    icon: StarIcon,
    activeIcon: StarIcon,
  },
  {
    key: "cameras",
    name: "Cameras",
    path: "/cameras",
    icon: CameraAltIcon,
    activeIcon: CameraAltIcon,
  },{
    key: "parents",
    name: "Parents",
    path: "/parents",
    icon: PersonIcon,
    activeIcon: PersonIcon,
  }
  // ,
  // {
  //   key: "ratings",
  //   name: "Ratings",
  //   path: "/ratings",
  //   icon: StarIcon,
  //   activeIcon: StarIcon,
  // },
  // {
  //   key: "notifications",
  //   name: "Notifications",
  //   path: "/notifications",
  //   icon: NotificationsIcon,
  //   activeIcon: NotificationsIcon,
  // }
];
